import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Truck, Clock, Shield, Undo2 } from 'lucide-react';
import styled from 'styled-components';

const Section = styled.section`
  padding: ${props => props.theme.spacing['3xl']} 0;
  background-color: ${props => props.theme.colors.background.muted}80;
  border-top: 1px solid ${props => props.theme.colors.border.main};
  border-bottom: 1px solid ${props => props.theme.colors.border.main};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing['2xl']};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${props => props.theme.spacing['2xl']};
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(4, 1fr);
    gap: ${props => props.theme.spacing['2xl']};
  }
`;

const FeatureCard = styled.div`
  text-align: center;
`;

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.primary.main}1A;
  color: ${props => props.theme.colors.primary.main};
  margin-bottom: ${props => props.theme.spacing.md};
  
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const FeatureTitle = styled.h4`
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
  color: ${props => props.theme.colors.text.primary};
  font-size: ${props => props.theme.typography.fontSize.sm};
  margin-bottom: ${props => props.theme.spacing.xs};
`;

const FeatureDescription = styled.p`
  font-size: ${props => props.theme.typography.fontSize.xs};
  color: ${props => props.theme.colors.text.muted};
  margin: 0;
`;

const ShippingInfoSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Clock,
      title: t('shipping.production'),
      description: t('shipping.productionDesc'),
    },
    {
      icon: Truck,
      title: t('shipping.delivery'),
      description: t('shipping.deliveryDesc'),
    },
    {
      icon: Shield,
      title: t('shipping.guarantee'),
      description: t('shipping.guaranteeDesc'),
    },
    {
      icon: Undo2,
      title: t('shipping.returns'),
      description: t('shipping.returnsDesc'),
    },
  ];

  return (
    <Section>
      <Container>
        <Grid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <IconWrapper>
                <feature.icon />
              </IconWrapper>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default ShippingInfoSection;
